import CampoMedico from 'components/medico/CampoMedico';
import { useFaturamento } from 'hooks/useFaturamento';
import FormMedico from 'pages/doctor/FormMedico';
import { useState } from 'react';
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';

const styles = {
  label: {
    minWidth: 76,
    marginBottom: 0,
    fontSize: '0.82rem',
    color: '#1f2937',
    textAlign: 'right',
    whiteSpace: 'nowrap',
    fontWeight: 600,
  },
  row: { display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 },
  compact: { minHeight: 30, padding: '0.12rem 0.45rem', fontSize: '0.84rem' },
  codeField: {
    backgroundColor: '#fff78a',
    fontWeight: 700,
    width: 70,
    flex: '0 0 70px',
    minHeight: 30,
    padding: '0.12rem 0.45rem',
    fontSize: '0.84rem',
  },
  disabled: {
    backgroundColor: '#e9ecef',
    minHeight: 30,
    padding: '0.12rem 0.45rem',
    fontSize: '0.84rem',
  },
  panel: {
    border: '1px solid #d6d9de',
    borderRadius: 6,
    padding: '0.6rem 0.75rem',
    background: '#f8fafc',
    height: '100%',
  },
  panelRight: {
    border: '2px solid #0d9488',
    borderRadius: 6,
    padding: '0.75rem',
    background: '#f0fdfa',
  },
};

function SelectComLimpar({ value, onChange, onClear, options = [], disabled, placeholder }) {
  const safeOptions = Array.isArray(options) ? options : [];

  return (
    <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
      <Form.Control
        as="select"
        size="sm"
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{ ...styles.compact, flex: 1, borderRadius: '4px 0 0 4px' }}
      >
        <option value="">{placeholder || 'Selecione'}</option>
        {safeOptions.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </Form.Control>
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={onClear}
        disabled={disabled}
        tabIndex={-1}
        title="Limpar"
        style={{
          borderRadius: '0 4px 4px 0',
          borderLeft: 'none',
          padding: '0 6px',
          minHeight: 30,
          fontSize: '0.75rem',
        }}
      >
        ×
      </Button>
    </div>
  );
}

// TODO: rever esse método onFaturado - estou em dúvida do papel dele.
// Talvez seja apenas para atualizar o status do faturamento -
// se for isso podemos descartar o método onFaturado.
export default function FaturamentoModal({ show, onHide, agenda, codFunc, nomeFunc, onFaturado }) {
  const [showNovoMedico, setShowNovoMedico] = useState(false);
  const [confirmExcluir, setConfirmExcluir] = useState(false);

  const codFuncAtivo = codFunc || agenda?.CODFUNC;
  const nomeFuncAtivo = nomeFunc || agenda?.NOMEFUNC;

  // Consumindo dados e estados diretamente do hook integrado
  const { modo, options, form, isSubmitting, error, valorAviso, realizouTravado, executarAcao } =
    useFaturamento({
      show,
      faturamentoInicial: agenda,
      codFunc: codFuncAtivo,
      nomeFunc: nomeFuncAtivo,
      onSucesso: onFaturado,
      onHide,
    });

  const onProximoCampo = (e) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const campos = document.querySelectorAll('[data-enter-nav="true"]');
    const index = Array.from(campos).indexOf(e.target);
    if (index >= 0 && index < campos.length - 1) {
      campos[index + 1].focus();
    }
  };

  const safeConvenios = Array.isArray(options?.convenios) ? options.convenios : [];
  const safeProcedimentos = Array.isArray(options?.procedimentos) ? options.procedimentos : [];

  const convenioOptions = safeConvenios.map((c) => ({
    value: String(c.CODCONV),
    label: `${c.CODCONV} - ${c.SIGLACONV}`,
  }));

  const procedimentoOptions = safeProcedimentos.map((p) => ({
    value: String(p.CODPROCEDI),
    label: `${p.CODPROCEDI} - ${p.DESCPROCEDI}`,
  }));

  // ✅ Formata a exibição do funcionário logado no header do modal
  const exibidacaoFuncAtivo = nomeFuncAtivo
    ? `${nomeFuncAtivo}${codFuncAtivo ? ` (${codFuncAtivo})` : ''}`
    : agenda?.NOMEFUNC || '';

  return (
    <Modal show={show} onHide={onHide} centered size="xl" backdrop="static">
      <Modal.Header
        closeButton
        style={{
          background: modo === 'EDITAR' ? 'rgb(6, 168, 217)' : 'rgb(235, 199, 37)',
          padding: '0.4rem 0.8rem',
        }}
      >
        <Modal.Title style={{ color: '#fff', fontSize: '0.95rem', fontWeight: 700 }}>
          {modo === 'EDITAR'
            ? `ALTERAR FATURAMENTO - #${agenda?.ID_FATURAMENTO || agenda?.CODFATURA}`
            : `FATURANDO AGENDA - #${agenda?.CODAGENDA}`}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '0.75rem 1rem' }}>
        <Row className="gx-3">
          <Col xs={12} md={showNovoMedico ? 8 : 12}>
            <div style={styles.panel}>
              {/* Header Info */}
              <Row className="gx-2 mb-2">
                <Col xs={6}>
                  <div style={styles.row}>
                    <span style={styles.label}>Data:</span>
                    <Form.Control
                      size="sm"
                      disabled
                      value={agenda?.dataFormatada || agenda?.DATAAGENDA || ''}
                      style={{ ...styles.disabled, flex: 1 }}
                    />
                  </div>
                </Col>
                <Col xs={6}>
                  <div style={styles.row}>
                    <span style={{ ...styles.label, minWidth: 44 }}>Func:</span>
                    <Form.Control
                      size="sm"
                      disabled
                      value={exibidacaoFuncAtivo}
                      style={{ ...styles.disabled, flex: 1, fontWeight: 600 }}
                    />
                  </div>
                </Col>
              </Row>

              {/* Paciente */}
              <div style={styles.row}>
                <span style={styles.label}>Paciente:</span>
                <Form.Control
                  size="sm"
                  disabled
                  value={agenda?.CODPAC || ''}
                  style={styles.codeField}
                  tabIndex={-1}
                />
                <Form.Control
                  size="sm"
                  disabled
                  value={agenda?.NOME || ''}
                  style={{ ...styles.disabled, flex: 1 }}
                />
              </div>

              <hr style={{ margin: '8px 0' }} />

              {/* Médicos */}
              <CampoMedico
                label="Físico/Jur"
                codMed={form.medConveniado.codMed}
                nomeMed={form.medConveniado.nome}
                onProximoCampo={onProximoCampo}
                onSelect={(m) => form.setMedConveniado({ codMed: String(m.codMed), nome: m.nome })}
                onCodigoChange={(codigo) =>
                  form.setMedConveniado((p) => ({ ...p, codMed: codigo }))
                }
                onClear={() => form.setMedConveniado({ codMed: '', nome: '' })}
                disabled={isSubmitting}
                styles={styles}
              />
              <CampoMedico
                label="Solicitou"
                codMed={form.medSolicitou.codMed}
                nomeMed={form.medSolicitou.nome}
                onProximoCampo={onProximoCampo}
                onSelect={(m) => form.setMedSolicitou({ codMed: String(m.codMed), nome: m.nome })}
                onCodigoChange={(codigo) => form.setMedSolicitou((p) => ({ ...p, codMed: codigo }))}
                onClear={() => form.setMedSolicitou({ codMed: '', nome: '' })}
                disabled={isSubmitting}
                styles={styles}
              />
              <CampoMedico
                label="Realizou"
                codMed={form.medRealizou.codMed}
                nomeMed={form.medRealizou.nome}
                onProximoCampo={onProximoCampo}
                onSelect={(m) => form.setMedRealizou({ codMed: String(m.codMed), nome: m.nome })}
                onCodigoChange={(codigo) => form.setMedRealizou((p) => ({ ...p, codMed: codigo }))}
                onClear={() => form.setMedRealizou({ codMed: '', nome: '' })}
                disabled={isSubmitting || realizouTravado}
                styles={styles}
              />

              <div className="d-flex justify-content-end mb-1">
                <Button
                  variant="link"
                  size="sm"
                  style={{ fontSize: '0.75rem', padding: 0 }}
                  onClick={() => setShowNovoMedico((prev) => !prev)}
                >
                  {showNovoMedico ? 'Fechar Novo Médico' : '+ Cadastrar Novo Médico'}
                </Button>
              </div>

              <hr style={{ margin: '4px 0 8px 0' }} />

              {/* Convênio */}
              <div style={styles.row}>
                <span style={styles.label}>Convênio:</span>
                <Form.Control
                  data-enter-nav="true"
                  size="sm"
                  value={form.convenio}
                  onChange={(e) => form.handleConvenioChange(e.target.value)}
                  style={styles.codeField}
                  onKeyDown={onProximoCampo}
                  onFocus={(e) => e.target.select()}
                  disabled={isSubmitting || options.isLoading}
                />
                <SelectComLimpar
                  value={form.convenio}
                  onChange={(e) => form.handleConvenioChange(e.target.value)}
                  onClear={() => {
                    form.setConvenio('');
                    form.setValor('');
                  }}
                  options={convenioOptions}
                  placeholder={
                    options.isLoading ? 'Carregando convênios...' : 'Selecione o convênio'
                  }
                  disabled={isSubmitting || options.isLoading}
                />
              </div>

              {/* Procedimento */}
              <div style={styles.row}>
                <span style={styles.label}>Proced:</span>
                <Form.Control
                  data-enter-nav="true"
                  size="sm"
                  value={form.procedimento}
                  onChange={(e) => form.handleProcedimentoChange(e.target.value)}
                  style={{ ...styles.codeField, backgroundColor: '#fff200' }}
                  onKeyDown={onProximoCampo}
                  onFocus={(e) => e.target.select()}
                  disabled={isSubmitting || options.isLoading}
                />
                <SelectComLimpar
                  value={form.procedimento}
                  onChange={(e) => form.handleProcedimentoChange(e.target.value)}
                  onClear={() => {
                    form.setProcedimento('');
                    form.setFaturarEcg(false);
                    form.setValor('');
                  }}
                  options={procedimentoOptions}
                  placeholder={
                    options.isLoading ? 'Carregando procedimentos...' : 'Selecione o procedimento'
                  }
                  disabled={isSubmitting || options.isLoading}
                />
              </div>

              {/* Opção ECG */}
              {modo !== 'EDITAR' && String(form.procedimento) === '1' && (
                <div
                  style={{
                    marginLeft: 76,
                    padding: '6px 8px',
                    backgroundColor: '#eff6ff',
                    borderRadius: 4,
                    border: '1px solid #bfdbfe',
                    marginBottom: 6,
                  }}
                >
                  <Form.Check
                    type="checkbox"
                    id="faturar-ecg-checkbox"
                    label="Faturar ECG (Cod. 2) junto com a Consulta?"
                    checked={form.faturarEcg}
                    onChange={(e) => form.setFaturarEcg(e.target.checked)}
                    disabled={isSubmitting}
                    style={{ fontSize: '0.82rem', fontWeight: 600, color: '#1e40af' }}
                  />

                  {form.faturarEcg && (
                    <div style={{ marginTop: 6 }}>
                      <div style={{ ...styles.row, marginBottom: 6 }}>
                        <span style={{ ...styles.label, minWidth: 68 }}>Conv. ECG:</span>
                        <Form.Control
                          data-enter-nav="true"
                          size="sm"
                          value={form.convenioEcg || ''}
                          onChange={(e) => form.handleConvenioEcgChange(e.target.value)}
                          disabled={isSubmitting || options.isLoading}
                          style={styles.codeField}
                          onKeyDown={onProximoCampo}
                          onFocus={(e) => e.target.select()}
                        />
                        <SelectComLimpar
                          value={form.convenioEcg || ''}
                          onChange={(e) => form.handleConvenioEcgChange(e.target.value)}
                          onClear={() => {
                            form.setConvenioEcg('');
                            form.setValorEcg('');
                          }}
                          options={convenioOptions}
                          placeholder={
                            options.isLoading ? 'Carregando convênios...' : 'Selecione o convênio'
                          }
                          disabled={isSubmitting || options.isLoading}
                        />
                      </div>

                      <div style={{ ...styles.row, marginBottom: 0 }}>
                        <span style={{ ...styles.label, minWidth: 68 }}>Guia ECG:</span>
                        <Form.Control
                          data-enter-nav="true"
                          size="sm"
                          value={form.guiaEcg || ''}
                          onChange={(e) => form.setGuiaEcg && form.setGuiaEcg(e.target.value)}
                          disabled={isSubmitting}
                          style={{ ...styles.compact, width: 120, flex: '0 0 120px' }}
                          placeholder="Nº guia ECG"
                          onKeyDown={onProximoCampo}
                          onFocus={(e) => e.target.select()}
                        />
                        <span style={{ ...styles.label, minWidth: 60, marginLeft: 8 }}>
                          Valor ECG:
                        </span>
                        <Form.Control
                          data-enter-nav="true"
                          size="sm"
                          value={form.valorEcg || ''}
                          onChange={(e) => form.setValorEcg && form.setValorEcg(e.target.value)}
                          disabled={isSubmitting}
                          style={{ ...styles.compact, width: 100, flex: '0 0 100px' }}
                          inputMode="decimal"
                          placeholder="0,00"
                          onKeyDown={onProximoCampo}
                          onFocus={(e) => e.target.select()}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {valorAviso === 'nao_encontrado' && (
                <Alert
                  variant="warning"
                  className="mb-1 py-1 px-2 d-flex align-items-center gap-2"
                  style={{ fontSize: '0.80rem', borderLeft: '4px solid #f59e0b' }}
                >
                  <span>⚠️</span>
                  <span>
                    Valor não encontrado para esta combinação. Informe o valor manualmente.
                  </span>
                </Alert>
              )}

              {/* Guia + Valor */}
              <div style={{ ...styles.row, marginTop: 4 }}>
                <span style={styles.label}>Guia:</span>
                <Form.Control
                  data-enter-nav="true"
                  size="sm"
                  value={form.guia}
                  onChange={(e) => form.setGuia(e.target.value)}
                  disabled={isSubmitting}
                  style={{ ...styles.compact, width: 120, flex: '0 0 120px' }}
                  placeholder="Nº guia"
                  onKeyDown={onProximoCampo}
                  onFocus={(e) => e.target.select()}
                />
                <span style={{ ...styles.label, minWidth: 52, marginLeft: 8 }}>Valor:</span>
                <Form.Control
                  data-enter-nav="true"
                  size="sm"
                  value={form.valor}
                  onChange={(e) => form.setValor(e.target.value)}
                  disabled={isSubmitting}
                  style={{ ...styles.compact, width: 100, flex: '0 0 100px' }}
                  inputMode="decimal"
                  placeholder="0,00"
                  onKeyDown={onProximoCampo}
                  onFocus={(e) => e.target.select()}
                />
              </div>

              {error && (
                <Alert variant="danger" className="mt-2 mb-0 py-1" style={{ fontSize: '0.82rem' }}>
                  {error}
                </Alert>
              )}

              {/* Botões de Ação CRUD */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div>
                  {modo === 'EDITAR' && !confirmExcluir && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => setConfirmExcluir(true)}
                      disabled={isSubmitting}
                    >
                      Excluir
                    </Button>
                  )}
                  {confirmExcluir && (
                    <div className="d-flex gap-1 align-items-center">
                      <span style={{ fontSize: '0.78rem', color: '#dc2626', fontWeight: 600 }}>
                        Confirmar?
                      </span>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => executarAcao('EXCLUIR')}
                        disabled={isSubmitting}
                      >
                        Sim
                      </Button>
                      <Button variant="light" size="sm" onClick={() => setConfirmExcluir(false)}>
                        Não
                      </Button>
                    </div>
                  )}
                </div>

                <div className="d-flex gap-2">
                  <Button
                    variant={modo === 'EDITAR' ? 'warning' : 'primary'}
                    size="sm"
                    onClick={() => executarAcao()}
                    disabled={isSubmitting}
                    style={{ minWidth: 90 }}
                  >
                    {isSubmitting ? (
                      <Spinner animation="border" size="sm" />
                    ) : modo === 'EDITAR' ? (
                      'Salvar'
                    ) : (
                      'Faturar'
                    )}
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={onHide}
                    disabled={isSubmitting}
                    style={{ minWidth: 90 }}
                  >
                    Cancelar
                  </Button>
                </div>
              </div>
            </div>
          </Col>

          {showNovoMedico && (
            <Col xs={12} md={4}>
              <FormMedico
                codFunc={codFuncAtivo}
                onProximoCampo={onProximoCampo}
                onCancelar={() => setShowNovoMedico(false)}
                onSucesso={() => setShowNovoMedico(false)}
                styles={styles}
              />
            </Col>
          )}
        </Row>
      </Modal.Body>
    </Modal>
  );
}
